import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { NumberingWizardPropsType } from "../../../../Type/FormLayoutType";
import { AgreeToTermsAndConditions, GitHubPlaceholder, Github, GiveFeedback, LinkedIn, LinkedInPlaceholder, SelectState } from "../../../../Constant";

const FeedbackForm = ({ getUserData, basicInputFormValue }: NumberingWizardPropsType) => {
  const { linkedInLink, gitHubLink, giveFeedBack } = basicInputFormValue;

  return (
    <Form className="stepper-three g-3 needs-validation custom-input" noValidate>
      <Row>
      <Col sm="6" className="mb-3">
        <Label check>{LinkedIn}<span className="txt-danger">*</span></Label>
        <Input name="linkedInLink" value={linkedInLink} onChange={getUserData} type="url" placeholder={LinkedInPlaceholder} />
      </Col>
      <Col sm="6" className="mb-3">
        <Label check>{Github}<span className="txt-danger">*</span></Label>
        <Input name="gitHubLink" value={gitHubLink} onChange={getUserData} type="url" placeholder={GitHubPlaceholder} />
      </Col>
      <Col xs="12" className="mb-3">
        <Label check>{SelectState}<span className="txt-danger">*</span></Label>
        <Input type="select" name="state" onChange={getUserData}>
          <option value="">Choose...</option>
          <option value="U.K">U.K </option>
          <option value="U.S">U.S </option>
          <option value="India">India</option>
        </Input>
      </Col>
      <Col xs="12" className="mb-3">
        <Label>{GiveFeedback}</Label>
        <Input type="textarea" name="giveFeedBack" value={giveFeedBack} onChange={getUserData} />
      </Col>
      <Col xs="12">
        <FormGroup check>
          <Input id="invalidCheck46" name="agreeConditions" onChange={getUserData} type="checkbox" required />
          <Label className="form-check-label mb-0" htmlFor="invalidCheck46" check>{AgreeToTermsAndConditions}</Label>
        </FormGroup>
      </Col>
      </Row>
    </Form>
  );
};

export default FeedbackForm;
